// Servicio híbrido de geolocalización para personas mayores
export const obtenerUbicacionAmigable = async () => {
  return new Promise(async (resolve) => {
    console.log('🌍 Iniciando obtención de ubicación...');
    
    try {
      // Intentar GPS primero con timeout corto
      const ubicacionGPS = await Promise.race([
        new Promise((resolve, reject) => {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              console.log('📍 GPS obtenido exitosamente');
              resolve({
                lat: position.coords.latitude,
                lon: position.coords.longitude,
                precision: 'GPS',
                mensaje: 'Ubicación obtenida con GPS'
              });
            },
            (error) => reject(error),
            { enableHighAccuracy: true, timeout: 3000, maximumAge: 0 }
          );
        }),
        // Timeout de 3 segundos
        new Promise((_, reject) => 
          setTimeout(() => reject(new Error('GPS timeout')), 3000)
        )
      ]);
      
      resolve(ubicacionGPS);
      
    } catch (gpsError) {
      console.log('⚠️ GPS no disponible, usando servicios IP como respaldo');
      
      // Lista de servicios de IP con respaldo
      const serviciosIP = [
        'https://ipapi.co/json/',
        'https://api.ipify.org?format=json',
        'https://httpbin.org/ip'
      ];
      
      for (const servicio of serviciosIP) {
        try {
          const response = await fetch(servicio);
          const data = await response.json();
          
          // Procesar según el servicio
          if (servicio.includes('ipapi.co') && data.latitude) {
            console.log('🌐 Ubicación por ipapi.co:', data.city, data.region);
            resolve({
              lat: data.latitude,
              lon: data.longitude,
              precision: 'IP',
              ciudad: data.city,
              region: data.region,
              mensaje: `Ubicación aproximada: ${data.city}, ${data.region}`
            });
            return;
          }
          
        } catch (error) {
          console.log(`❌ Error con ${servicio}:`, error.message);
          continue;
        }
      }
      
      // Si todos los servicios fallan, usar ubicación por defecto
      console.log('❌ Todos los servicios fallaron, usando ubicación por defecto');
      resolve({
        lat: 5.0214,
        lon: -74.0052,
        precision: 'DEFAULT',
        ciudad: 'Zipaquirá',
        region: 'Cundinamarca',
        mensaje: 'Ubicación predeterminada: Zipaquirá, Cundinamarca'
      });
    }
  });
};